import { useQuery } from '@tanstack/react-query'
import { API_BASE_URL } from '../config'

export type ReadinessStatus = 'ok' | 'warn' | 'fail' | 'skipped'
export type OverallStatus = 'ok' | 'warn' | 'fail'

export interface ReadinessCheck {
  id: string
  label: string
  status: ReadinessStatus
  detail: string | null
  remediation: string | null
}

export interface ReadinessReport {
  tenant_name: string
  tenant_goid: string
  checks: ReadinessCheck[]
  overall: OverallStatus
  generated_at: string
}

async function fetchReadiness(tenantName: string): Promise<ReadinessReport> {
  const token = localStorage.getItem('accessToken')
  const response = await fetch(
    `${API_BASE_URL}/meta/tenant/${encodeURIComponent(tenantName)}/readiness`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-Tenant-Name': 'Gravitate',
      },
    },
  )
  if (!response.ok) {
    throw new Error(
      `Failed to fetch readiness: ${response.status} ${await response.text()}`,
    )
  }
  return (await response.json()) as ReadinessReport
}

export function useTenantReadiness(tenantName: string | undefined) {
  return useQuery<ReadinessReport>({
    queryKey: ['tenant-readiness', tenantName],
    enabled: !!tenantName,
    refetchInterval: 30_000,
    queryFn: () => fetchReadiness(tenantName ?? ''),
  })
}
